import { object, string, number, array, InferType } from 'yup';
import { DayAndHourPickerRowSchema } from '../../../components/common/Form';

export const AddressSchema = object({
  address1: string().trim().default('').required('Street address is required.'),
  address2: string().trim().default(''),
  city: string().trim().default('').required('City is required.'),
  governingDistrict: string().trim().default('').required('State is required.'),
  postCode: string().trim().default('').required('Zip code is required.')
});

export const RestaurantSocialsSchema = object({
  facebook: string().trim().default(''),
  instagram: string().trim().default(''),
  snapchat: string().trim().default(''),
  tiktok: string().trim().default(''),
  twitter: string().trim().default('')
});

export const RestaurantWizardSchema = object({
  name: string().trim().default('').required('Name is required.'),
  description: string().trim().default(''),
  primaryTagline: string().trim().default(''),
  secondaryTagline: string().trim().default(''),
  phone: string()
    .trim()
    .default('')
    .min(12, 'Phone number must be at least 10 digits long.')
    .required('Phone number is required.'),
  email: string().trim().default('').email('Email is not valid.').required('Email is required.'),
  cuisine: number().default(1).required('Cuisine is required.'),
  layoutID: number().default(1),
  website: string().trim().default(''),
  address: AddressSchema.default(AddressSchema.cast({})).required('Address is required.'),
  socials: RestaurantSocialsSchema.default(RestaurantSocialsSchema.cast({})),
  restaurantHours: array()
    .of(DayAndHourPickerRowSchema)
    .default([DayAndHourPickerRowSchema.cast({ id: crypto.randomUUID() })]),
  availabilityNotes: string().trim().default('')
});

export type RestaurantWizardFormValues = InferType<typeof RestaurantWizardSchema>;
